import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Surface = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4H19C20.1 4 21 4.9 21 6V18C21 19.1 20.1 20 19 20H5C3.9 20 3 19.1 3 18V6C3 4.9 3.9 4 5 4ZM6 18H18C18.55 18 19 17.55 19 17V7C19 6.45 18.55 6 18 6H6C5.45 6 5 6.45 5 7V17C5 17.55 5.45 18 6 18Z"
        fill="currentColor"
      />
      <path
        id="Path"
        d="M17 12C16.45 12 16 12.45 16 13V15H14C13.45 15 13 15.45 13 16C13 16.55 13.45 17 14 17H17C17.55 17 18 16.55 18 16V13C18 12.45 17.55 12 17 12Z"
        fill="currentColor"
      />
      <path
        id="Path_2"
        d="M8 9H10C10.55 9 11 8.55 11 8C11 7.45 10.55 7 10 7H7C6.45 7 6 7.45 6 8V11C6 11.55 6.45 12 7 12C7.55 12 8 11.55 8 11V9Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Surface;
